var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echart-wrapper"},_vm._l((_vm.optionArray),function(item,index){return _c('div',{key:'item'+index,staticClass:"echart-content"},[_c('Echart',{ref:"echartOption",refInFor:true,staticClass:"echart-content-item",style:({height: `${item.height}px`,width:'100%'}),attrs:{"option":item.option}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }